module.exports = __webpack_public_path__ + "efc32b2d7313b354213dbb2e520be8cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/clock.png
// module id = 3693
// module chunks = 0